import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import { ElMessage } from "element-plus";

// 公众端页面
const PublicLayout = () => import("@/views/public/Layout.vue");
const Home = () => import("@/views/public/Home.vue");
const News = () => import("@/views/public/News.vue");
const Companies = () => import("@/views/public/Companies.vue");
const Products = () => import("@/views/public/Products.vue");
const Services = () => import("@/views/public/Services.vue");
const Reports = () => import("@/views/public/Reports.vue");
const CompanyDetail = () => import("@/views/public/CompanyDetail.vue");
const ProductDetail = () => import("@/views/public/ProductDetail.vue");
const CompanyNewsDetail = () => import("@/views/public/CompanyNewsDetail.vue");

// 企业端页面
const CompanyLayout = () => import("@/views/company/Layout.vue");
const CompanyDashboard = () => import("@/views/company/Dashboard.vue");
const CompanyProfile = () => import("@/views/company/Profile.vue");
const ProductManagement = () => import("@/views/company/ProductManagement.vue");
const ServiceManagement = () => import("@/views/company/ServiceManagement.vue");
const NewsManagement = () => import("@/views/company/NewsManagement.vue");
const VideoManagement = () => import("@/views/company/VideoManagement.vue");
const InquiryManagement = () => import("@/views/company/InquiryManagement.vue");
const QuotationManagement = () =>
  import("@/views/company/QuotationManagement.vue");

// 运营端页面
const AdminLayout = () => import("@/views/admin/Layout.vue");
const AdminDashboard = () => import("@/views/admin/Dashboard.vue");
const UserManagement = () => import("@/views/admin/UserManagement.vue");
const CompanyAudit = () => import("@/views/admin/CompanyAudit.vue");
const DataAnalysis = () => import("@/views/admin/DataAnalysis.vue");
const SystemSettings = () => import("@/views/admin/SystemSettings.vue");

// 通用页面
const Login = () => import("@/views/auth/Login.vue");
const Register = () => import("@/views/auth/Register.vue");
const NotFound = () => import("@/views/error/404.vue");

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  // 公众端路由
  {
    path: "/",
    component: PublicLayout,
    children: [
      {
        path: "home",
        name: "Home",
        component: Home,
        meta: { title: "首页" },
      },
      {
        path: "news",
        name: "News",
        component: News,
        meta: { title: "资讯" },
      },
      {
        path: "news/:id",
        name: "NewsDetail",
        component: () => import("@/views/public/NewsDetail.vue"),
        meta: { title: "资讯详情" },
      },
      {
        path: "companies",
        name: "Companies",
        component: Companies,
        meta: { title: "公司" },
      },
      {
        path: "products",
        name: "Products",
        component: Products,
        meta: { title: "产品" },
      },
      {
        path: "services",
        name: "Services",
        component: Services,
        meta: { title: "服务" },
      },
      {
        path: "reports",
        name: "Reports",
        component: Reports,
        meta: { title: "行业报告" },
      },
      {
        path: "company/:id",
        name: "CompanyDetail",
        component: CompanyDetail,
        meta: { title: "公司详情" },
      },
      {
        path: "product/:id",
        name: "ProductDetail",
        component: ProductDetail,
        meta: { title: "产品详情" },
      },
      {
        path: "service/:id",
        name: "ServiceDetail",
        component: () => import("@/views/public/ServiceDetail.vue"),
        meta: { title: "服务详情" },
      },
      {
        path: "report/:id",
        name: "ReportDetail",
        component: () => import("@/views/public/ReportDetail.vue"),
        meta: { title: "报告详情" },
      },
      {
        path: "companyNews/:id",
        name: "CompanyNewsDetail",
        component: CompanyNewsDetail,
        meta: { title: "资讯详情" },
      },
    ],
  },
  // 企业端路由
  {
    path: "/company",
    component: CompanyLayout,
    meta: { requiresAuth: true, userType: [1] },
    children: [
      {
        path: "dashboard",
        name: "CompanyDashboard",
        component: CompanyDashboard,
        meta: { title: "企业中心" },
      },
      {
        path: "profile",
        name: "CompanyProfile",
        component: CompanyProfile,
        meta: { title: "企业信息" },
      },
      {
        path: "products",
        name: "ProductManagement",
        component: ProductManagement,
        meta: { title: "产品管理" },
      },
      {
        path: "services",
        name: "ServiceManagement",
        component: ServiceManagement,
        meta: { title: "服务管理" },
      },
      {
        path: "news",
        name: "NewsManagement",
        component: NewsManagement,
        meta: { title: "资讯管理" },
      },
      {
        path: "videos",
        name: "VideoManagement",
        component: VideoManagement,
        meta: { title: "视频管理" },
      },
      {
        path: "inquiries",
        name: "InquiryManagement",
        component: InquiryManagement,
        meta: { title: "询价管理" },
      },
      {
        path: "quotations",
        name: "QuotationManagement",
        component: QuotationManagement,
        meta: { title: "报价管理" },
      },
    ],
  },
  // 运营端路由
  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAuth: true, userType: [3] },
    children: [
      {
        path: "dashboard",
        name: "AdminDashboard",
        component: AdminDashboard,
        meta: { title: "管理中心" },
      },
      {
        path: "users",
        name: "UserManagement",
        component: UserManagement,
        meta: { title: "用户管理" },
      },
      {
        path: "company-audit",
        name: "CompanyAudit",
        component: CompanyAudit,
        meta: { title: "企业审核" },
      },
      {
        path: "analysis",
        name: "DataAnalysis",
        component: DataAnalysis,
        meta: { title: "数据分析" },
      },
      {
        path: "settings",
        name: "SystemSettings",
        component: SystemSettings,
        meta: { title: "系统设置" },
      },
    ],
  },
  // 认证路由
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { title: "登录" },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { title: "注册" },
  },
  // 404页面
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { title: "页面不存在" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  // mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 三相资源网`;
  }

  // 检查登录状态
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.log(store.getters["auth/isLoggedIn"]);
    if (!store.getters["auth/isLoggedIn"]) {
      ElMessage.warning("请先登录");
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
      return;
    }

    // 检查用户类型权限
    console.log(to.meta);
    console.log(store.getters["auth/userInfo"]);
    const userType = store.getters["auth/userInfo"]?.userType;
    // if (to.meta.userType && !to.meta.userType.includes(userType)) {
    //   ElMessage.error("没有访问权限");
    //   next("/");
    //   return;
    // }
  }

  next();
});

export default router;
